import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70f402e2&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=70f402e2&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=70f402e2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f402e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f402e2')) {
      api.createRecord('70f402e2', component.options)
    } else {
      api.reload('70f402e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70f402e2&scoped=true&", function () {
      api.rerender('70f402e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/new-position-modal/index.vue"
export default component.exports